import React, { useEffect, useState } from "react";
import WebAppContainer from "@/components/WebAppContainer/WebAppContainer";
import { motion } from "framer-motion";
import Modal from "@/ui/Modal/Modal";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import BlockPayButton, {
  SubscriptionForm,
} from "@/features/PaymentsModal/PaymentStates";
import { useTranslation } from "react-i18next";
import { SubscriptionBlock } from "@/components/WelcomeModal/SrdComponents/SubscriptionBlock";
import { RatingBlock } from "@/components/WelcomeModal/SrdComponents/RatingBlock";
import { useServiceType } from "@/utils/hooks/useServiceType";
import cls from "./styles.module.scss";

interface InfoBlockProps {
  showForm: boolean;
  setShowForm: (value: boolean) => void;
}

const InfoBlockKef = ({ showForm, setShowForm }: InfoBlockProps) => {
  const { t } = useTranslation();

  if (showForm)
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <SubscriptionForm backBtn={() => setShowForm(false)} />
      </motion.div>
    );

  return (
    <FlexColumn gap={16}>
      <Typography className={cls.heading}>
        {t("welcomeModal.advantageousPoints")}
      </Typography>

      <Typography className={cls.notActiveText}>
        {t("welcomeModal.chooseYourOption")}
      </Typography>

      <FlexColumn gap={8} className={cls.infoBlock}>
        <BlockPayButton onClick={() => setShowForm(true)} />
      </FlexColumn>
    </FlexColumn>
  );
};

const InfoBlockSrd = ({ showForm, setShowForm }: InfoBlockProps) => {
  const { t } = useTranslation();

  if (showForm)
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <SubscriptionForm backBtn={() => setShowForm(false)} />
      </motion.div>
    );

  return (
    <FlexColumn gap={16}>
      <Typography className={cls.heading}>
        {t("welcomeModal.advantageousPoints")}
      </Typography>

      <Typography className={cls.notActiveTextSrd}>
        Сравнивай реальный доход по городу между сервисами
      </Typography>

      <FlexColumn gap={14} className={cls.infoBlock}>
        <RatingBlock />

        <SubscriptionBlock onClick={() => setShowForm(true)} />
      </FlexColumn>
    </FlexColumn>
  );
};

export const NotRegisteredModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const { isSravniDohod } = useServiceType();

  useEffect(() => {
    setIsOpen(true);
  }, []);

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      wrapperCls={!showForm ? cls.wrapperNotActiveStatus : undefined}
      contentCls={cls.fullHeight}
      isOpen={isOpen}
      onClose={onClose}
      hideCloseBtn
      ignoreTranslate
      closeOnBackdropClick={!showForm}
    >
      <WebAppContainer>
        {isSravniDohod ? (
          <InfoBlockSrd showForm={showForm} setShowForm={setShowForm} />
        ) : (
          <InfoBlockKef showForm={showForm} setShowForm={setShowForm} />
        )}
      </WebAppContainer>
    </Modal>
  );
};
